import * as z from "zod/v4";

export const getUcpManifest = {
  name: "getUcpManifest" as const,
  input: z.null(),
  output: z.object({ manifest: z.string() }),
};
